import { createSlice } from '@reduxjs/toolkit';
import { encryptStorage } from '../../encryptStorage';

interface AuthReducerState {
  token: string | null;
  refresh_token: string | null;
  isAuthenticated: boolean;
  isSuperUser: boolean;
  tokenExpired: boolean;
}

const initialState = {
  token: null,
  refresh_token: null,
  isAuthenticated: false,
  isSuperUser: false,
  tokenExpired: false,
} satisfies AuthReducerState as AuthReducerState;

export const authReducer = createSlice({
  name: 'authReducer',
  initialState,
  reducers: {
    login: (state, action) => {
      state.token = action.payload.token;
      state.refresh_token = action.payload.refresh_token;
      state.isAuthenticated = true;

      // Store tokens
      encryptStorage.setItem('token', action.payload.token);
      encryptStorage.setItem('refresh_token', action.payload.refresh_token);

      // Store role
      if (action.payload.role?.name) {
        localStorage.setItem('user_role', action.payload.role.name);
      }

      state.tokenExpired = false;
    },
    logout: state => {
      state.token = null;
      state.refresh_token = null;
      state.isAuthenticated = false;
      state.isSuperUser = false;
      encryptStorage.removeItem('token');
      encryptStorage.removeItem('refresh_token');
      localStorage.removeItem('user_role');
      encryptStorage.removeItem('is_superuser');
      state.tokenExpired = true;
    },
    expireToken: state => {
      state.tokenExpired = true;
    },
    setAccessToken: (state, action) => {
      state.token = action.payload;
      encryptStorage.setItem('token', action.payload);
    },
    setSuperUser: (state, action) => {
      // Handle superuser
      state.isSuperUser = action.payload;
      encryptStorage.setItem('is_superuser', action.payload ? 'true' : 'false');
    },
    rehydrateAuthState: state => {
      const token = encryptStorage.getItem('token');
      const refreshToken = encryptStorage.getItem('refresh_token');
      const isSuperUser = encryptStorage.getItem('is_superuser');

      state.token = token;
      state.refresh_token = refreshToken;
      state.isAuthenticated = !!token;
      state.isSuperUser = isSuperUser;
    },
  },
});
export const { login, logout, expireToken, setSuperUser, rehydrateAuthState } = authReducer.actions;

export default authReducer.reducer;
